import React, { useState } from "react";
import {
  FaPlus,
  FaKey,
  FaTrash,
  FaEdit,
  FaCopy,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";

const ApiKeys = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showKey, setShowKey] = useState({});

  const [apiKeys, setApiKeys] = useState([
    {
      id: 1,
      name: "Production API Key",
      key: "sk_live_4f3d8c2b1a9e7f6d5c4b3a2e1f0d9c8b7a6e5f4d3c2b1a0",
      created: "2024-01-15",
      status: "active",
      usage: 125000,
    },
    {
      id: 2,
      name: "Development API Key",
      key: "sk_test_1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z",
      created: "2024-01-10",
      status: "active",
      usage: 25000,
    },
  ]);

  const handleCopy = (key) => {
    navigator.clipboard.writeText(key);
  };

  const toggleKeyVisibility = (id) => {
    setShowKey((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const maskKey = (key) => {
    return key.substring(0, 10) + "..." + key.substring(key.length - 4);
  };

  return (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col-md-8">
          <h1 className="h3 mb-0">API Keys</h1>
          <p className="text-muted">
            Manage your API keys and access credentials
          </p>
        </div>
        <div className="col-md-4 text-end">
          <button
            className="btn btn-primary"
            onClick={() => setShowCreateModal(true)}
          >
            <FaPlus className="me-2" />
            Create New Key
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">Your API Keys</h5>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>API Key</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Usage</th>
                      <th className="biz-col-actions">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiKeys.map((key) => (
                      <tr key={key.id}>
                        <td>
                          <div className="d-flex align-items-center">
                            <FaKey className="me-2 text-muted" />
                            <strong>{key.name}</strong>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <code className="me-2">
                              {showKey[key.id] ? key.key : maskKey(key.key)}
                            </code>
                            <button
                              className="btn btn-link p-0 me-2"
                              onClick={() => toggleKeyVisibility(key.id)}
                            >
                              {showKey[key.id] ? <FaEyeSlash /> : <FaEye />}
                            </button>
                            <button
                              className="btn btn-link p-0"
                              onClick={() => handleCopy(key.key)}
                            >
                              <FaCopy />
                            </button>
                          </div>
                        </td>
                        <td>
                          <span
                            className={`badge bg-${key.status === "active" ? "success" : "secondary"}`}
                          >
                            {key.status}
                          </span>
                        </td>
                        <td>{key.created}</td>
                        <td>{key.usage.toLocaleString()} calls</td>
                        <td className="biz-col-actions">
                          <div className="biz-table-actions">
                            <button className="btn btn-outline-primary btn-sm">
                              <FaEdit />
                            </button>
                            <button className="btn btn-outline-danger btn-sm">
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeys;
